var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout dashboard"},[_c('stats-form',{model:{value:(_vm.stats),callback:function ($$v) {_vm.stats=$$v},expression:"stats"}}),_c('stats-result',{attrs:{"stats":_vm.stats}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }